import AppHeaderActionBar from '@/shared/components/layout/AppHeaderActionBar';
import AppHeaderBreadcrumbTrail from '@/shared/components/layout/AppHeaderBreadcrumbTrail';
import MyContext from '@/shared/contexts/AppContext';
import { useAppPageHeader } from '@/shared/hooks/useAppPageHeader';
import { useContext } from 'react';

/** Layout legado (Navbar): trilha + título + barra de ações, sem busca/usuário. */
export default function Breadcrumb() {
  const appContext = useContext(MyContext);
  if (!appContext) throw new Error('Breadcrumb deve ser usado dentro de um MyProvider.');

  const {
    titulo,
    showBreadcrumb,
    showActionBar,
    hasActions,
    actions,
    breadcrumbItems,
    isPaginaInicial,
  } = useAppPageHeader();

  if (isPaginaInicial && !showActionBar) {
    return null;
  }

  return (
    <div className="app-page-chrome app-page-chrome--legacy d-print-none">
      <header className="app-header app-header--legacy">
        <div className="app-header__row">
          <div className="app-header__left">
            {showBreadcrumb && <AppHeaderBreadcrumbTrail items={breadcrumbItems} />}
          </div>
          <div className="app-header__center">
            <h1 className="app-header__title">{titulo}</h1>
          </div>
          <div className="app-header__right" aria-hidden />
        </div>
      </header>

      {showActionBar && (
        <AppHeaderActionBar hasActions={hasActions} actions={actions} />
      )}
    </div>
  );
}
